<template>
  <button @click="list" type="button"
          class="btn btn-sm btn-secondary mr-1">
    <font-awesome-icon icon="list"/>&nbsp;{{ $t('listOfTemplates') }}
    <b-modal modal-class="modal-fullscreen" content-class="modal-content-2" size="xl" header-class="pb-0" min
             header-bg-variant="white"
             v-model="showList" hide-footer ok-only no-close-on-backdrop no-enforce-focus>
      <template #modal-title>
        <font-awesome-icon icon="list"/>&nbsp;{{ $t('listOfTemplates') }}
      </template>
      <main>
        <div class="row">
          <div class="col-12">
            <div class="tile">
              <div class="form-inline">
                <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword"
                              :placeholder="$t('keyword')" v-on:keydown.enter="load"></b-form-input>
                <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-1" :options="[
                {value: 0, text: $t('all')},
                {value: 1, text: $t('activated')},
                {value: 2, text: $t('deactivated')}
            ]"></form-select>
                <client-select v-if="!client && !facebookPage" :model="filterFormModel" class="mr-1 mb-1"
                               attribute="client" @change="search"
                               :isFilter="true" :place-holder="$t('selectClient') "></client-select>
                <social-net-work-account-select :disabled="!!facebookPage" :model="filterFormModel" class="mr-1 mb-1"
                                                attribute="account" @change="search"
                                                :isFilter="true" :filter="facebookFilter" :is-filter="true"/>

                <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
                <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="c-sorting"
                 v-if="['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)">
              <div class="row">
                <div class="col-lg-12 c-sorting__right">
                  <div class="c-sorting__btn">
                    <button @click="create" class="btn btn-sm btn-success">
                      <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-paging clearfix">
              <div class="c-paging__count" v-if="itemCount">
                {{ $t('found', [itemCount]) }}
              </div>
              <div class="c-paging__right">
                <div class="c-paging__numbers">
                  <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right"
                                size="sm"
                                v-model="filterFormModel.page" :total-rows="itemCount"
                                :per-page="filterFormModel.pageSize"
                                @input="load"></b-pagination>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="items.length">
            <div class="c-smart-table tile">
              <div class="row c-smart-table__title">
                <div class="col-lg-3">{{ $t('client') }}</div>
                <div class="col-lg-2">Facebook Page</div>
                <div class="col-lg-4">{{ $t('info') }}</div>
                <div class="col-lg-3"></div>
              </div>
              <div class="row" v-for="item in items" :key="item._id">
                <div class="col-lg-3">
                  <span v-if="item.client && item.client.companyName">{{ item.client.companyName }}</span>
                  <span v-if="item.client && item.client.domain">({{ item.client.domain }})</span>
                </div>
                <div class="col-lg-2">
                  <span v-if="item.account">{{ item.account.name }} ({{ item.account.facebookPageId }})</span>
                  <span v-else>{{ $t('unknown') }}</span>
                </div>
                <div class="col-lg-4">
                  <p>
                    <b>{{ $t('name') }}: </b>{{ item.name }}
                    <a v-if="item.previewUrl" :href="item.previewUrl" target="_blank"
                       class="small">({{ $t('seePreview') }})</a>
                  </p>
                  <p>
                    <b>{{ $t('type') }}: </b>{{ item.type ? $t(item.type) : $t('unknown') }}
                  </p>
                  <p>
                    <span v-if="item.active" class="badge badge-success">{{ $t('activated') }}</span>
                    <span v-else class="badge badge-danger">{{ $t('deactivated') }}</span>
                  </p>
                </div>
                <div class="col-lg-3">
                  <div class="c-smart-table__content">
                    <div class="c-buttons clearfix is-2 text-right">
                      <div class="c-buttons__col">
                        <button @click="showParams(item.params)" class="btn btn-sm btn-primary mr-1">
                          <font-awesome-icon icon="list"/>&nbsp;{{ $t('params') }}
                        </button>
                        <button @click="update(item._id)" type="button"
                                v-if="['owner','admin','tech', 'account', 'operationsManager'].includes($store.state.user.role)"
                                class="btn btn-sm btn-info mr-1">
                          <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 text-center text-danger" v-if="!items.length">
            <span>{{ $t('notFoundSearch') }}</span>
          </div>
          <div class="col-12" v-if="itemCount">
            <div class="c-paging__count" v-if="itemCount">
              {{ $t('found', [itemCount]) }}
            </div>
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize"
                          @input="load"></b-pagination>
          </div>
        </div>
        <b-modal v-model="showForm" :title="formTitle" no-close-on-backdrop no-enforce-focus size="lg">
          <form>
            <client-select :label="$t('client')" :model="formModel" attribute="client"
                           :errors="formErrors"></client-select>
            <social-net-work-account-select label="Facebook Page" :model="formModel" attribute="account"
                                            :filter="facebookFilter"/>
            <form-select :model="formModel" attribute="type" :errors="formErrors" :label="$t('type')" :options="[
              {value: null, text: $t('selectType')},
              {value: 'button', text: $t('button')},
              {value: 'coupon', text: $t('coupon')},
              {value: 'customer_feedback', text: $t('customer_feedback')},
              {value: 'customer_information', text: $t('customer_information')},
              {value: 'generic', text: $t('generic')},
              {value: 'media', text: $t('media')},
              {value: 'receipt', text: $t('receipt')}
        ]"></form-select>
            <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
            <form-textarea :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"
                           :row="5"></form-textarea>
            <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active"
                           :errors="formErrors"></form-checkbox>
          </form>
          <template v-slot:modal-footer>
            <button @click="showForm=false" class="btn btn-secondary">{{ $t('cancel') }}</button>
            <button disabled @click="save" class="btn btn-primary">{{ $t('save') }}</button>
          </template>
        </b-modal>
        <b-modal v-model="showParamsModel" :title="$t('paramList')" no-close-on-backdrop no-enforce-focus size="xl">
          <div class="col-12" v-if="params && params.length">
            <div class="c-smart-table tile">
              <div class="row c-smart-table__title">
                <div class="col-lg-3">{{ $t('name') }}</div>
                <div class="col-lg-3">{{ $t('require') }}</div>
                <div class="col-lg-3">{{ $t('dataType') }}</div>
                <div class="col-lg-3">{{ $t('acceptNull') }}</div>
              </div>
              <div class="row" v-for="item in params" :key="item._id">
                <div class="col-lg-3">{{ item.name }}</div>
                <div class="col-lg-3">{{ item.require ? $t('yes') : $t('no') }}</div>
                <div class="col-lg-3">{{ item.dataType }}</div>
                <div class="col-lg-3">{{ item.acceptNull ? $t('yes') : $t('no') }}</div>
              </div>
            </div>
          </div>
          <div v-else class="text-center">{{ $t('noParamFound') }}</div>
        </b-modal>
      </main>
    </b-modal>
  </button>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import SocialNetWorkAccountSelect from "@/components/SocialNetWorkAccountSelect";
import ClientSelect from "@/components/ClientSelect";
import _ from 'lodash';

export default {
  props: {
    client: Object,
    facebookPage: Object,
  },
  mixins: [list, crud],
  components: {ClientSelect, SocialNetWorkAccountSelect},
  data: function () {
    return {
      defaultFilterFormModel: {
        status: 1,
        client: this.client ? this.client._id : null,
        account: this.facebookPage ? this.facebookPage._id : null,
        type: null,
        keyword: null,
      },
      autoLoad: false,
      service: '/facebook-template',
      defaultFormModel: {
        status: 1,
        client: this.client ? this.client._id : null,
        account: null,
        type: null,
      },
      facebookFilter: {
        type: "facebook",
        client: this.client ? this.client._id : null,
      },
      showParamsModel: false,
      params: [],
      showList: false,
    }
  },
  watch: {
    "formModel.client": {
      handler(val) {
        this.facebookFilter.client = val;
      }
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    showParams(params) {
      this.params = params;
      this.showParamsModel = true;
    },
    list() {
      this.showList = true;
      this.autoLoad = true;
      this.reset();
    },
  },
  i18n: {
    messages: {
      en: {
        params: 'Params',
        noParamFound: 'No param found',
        paramList: 'Param list',
        require: 'Require',
        dataType: 'Data type',
        acceptNull: 'Accept null',
        selectType: "Select type",
        button: "Button",
        coupon: "Coupon",
        customer_feedback: "Customer feedback",
        customer_information: "Customer information",
        generic: "Generic",
        media: "Media",
        receipt: "Receipt",
        listOfTemplates: "List of Templates",
      },
      vi: {
        params: 'Tham số',
        noParamFound: 'Chưa có param nào',
        paramList: 'Danh sách tham số',
        require: 'Bắt buộc',
        dataType: 'Loại dữ liệu',
        acceptNull: 'Chấp nhận giá trị null',
        selectType: "Chọn loại",
        button: "Nút bấm",
        coupon: "Mã giảm giá",
        customer_feedback: "Phản hồi của khách hàng",
        customer_information: "Thông tin khách hàng",
        generic: "Mẫu chung",
        media: "Đa phương tiện",
        receipt: "Biên lai",
        listOfTemplates: "Danh sách Template",
      }
    }
  }
}
</script>